import { Fragment } from "react";
import { esSoloLectura } from './clientesCaps';
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { surfaceFromHost } from "../surface";

const Ico = ({ d }) => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d={d}/>
  </svg>
);

const ICONS = {
  grid:     "M3 3h7v7H3zm11 0h7v7h-7zM3 14h7v7H3zm11 0h7v7h-7z",
  phone:    "M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8 19.79 19.79 0 01.22 1.22 2 2 0 012.22 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.09a16 16 0 006 6l.66-.66a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92v2z",
  bar:      "M18 20V10M12 20V4M6 20v-6",
  network:  "M9 3H5a2 2 0 00-2 2v4m6-6h10a2 2 0 012 2v4M9 3v18m0 0h10a2 2 0 002-2V9M9 21H5a2 2 0 01-2-2V9m0 0h18",
  share:    "M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8M16 6l-4-4-4 4M12 2v13",
  users:    "M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 11a4 4 0 100-8 4 4 0 000 8zm14 10v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75",
  user_add: "M16 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M8.5 11a4 4 0 100-8 4 4 0 000 8zM20 8v6M23 11h-6",
  credit:   "M1 4h22v16H1zM1 10h22",
  hash:     "M4 9h16M4 15h16M10 3l-2 18M16 3l-2 18",
  check:    "M22 11.08V12a10 10 0 11-5.93-9.14M22 4L12 14.01l-3-3",
  shield:   "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z",
  gear:     "M12 15a3 3 0 100-6 3 3 0 000 6zm6.93-3a8 8 0 01-.07 1.08l2.3 1.8a.5.5 0 01.12.65l-2.18 3.78a.5.5 0 01-.61.22l-2.72-1.09a8 8 0 01-1.87 1.09l-.41 2.9a.49.49 0 01-.49.42H7.82a.49.49 0 01-.49-.43l-.41-2.9A8 8 0 014.93 18l-2.72 1.09a.5.5 0 01-.61-.22L-.38 15.09a.5.5 0 01.12-.65l2.3-1.8A8.4 8.4 0 012 12c0-.37.02-.73.07-1.08l-2.3-1.8a.5.5 0 01-.12-.65l2.18-3.78a.5.5 0 01.61-.22l2.72 1.09A8 8 0 016.93 4.5l.41-2.9A.49.49 0 017.83 1h4.36c.26 0 .47.19.49.43l.41 2.9a8 8 0 011.87 1.09l2.72-1.09a.5.5 0 01.61.22l2.18 3.78a.5.5 0 01-.12.65l-2.3 1.8c.05.35.07.71.07 1.08z",
  alert:    "M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0zM12 9v4M12 17h.01",
  api:      "M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5",
  reseller: "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z M9 22V12h6v10",
  mobile:   "M5 2h14a2 2 0 012 2v16a2 2 0 01-2 2H5a2 2 0 01-2-2V4a2 2 0 012-2zM12 18h.01",
  mic:      "M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3zM19 10v2a7 7 0 01-14 0v-2M12 19v4M8 23h8",
  search:   "M11 19a8 8 0 100-16 8 8 0 000 16zM21 21l-4.35-4.35",
  live:     "M5 3l14 9-14 9V3z",
  signal:   "M1.5 8.5s5-5 10.5-5 10.5 5 10.5 5M5 12s3.5-3.5 7-3.5S19 12 19 12M8.5 15.5s2-2 3.5-2 3.5 2 3.5 2M12 19h.01",
  lock:     "M19 11H5a2 2 0 00-2 2v7a2 2 0 002 2h14a2 2 0 002-2v-7a2 2 0 00-2-2zM7 11V7a5 5 0 0110 0v4",
  bill:     "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8zM14 2v6h6M16 13H8M16 17H8M10 9H8",
  document: "M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8zM14 2v6h6M16 13H8M16 17H8M10 9H8",
};

const I = ({ n }) => <Ico d={ICONS[n]||ICONS.grid}/>;

const RESELLER_PATHS = ["/reseller-dashboard", "/reseller-cdrs", "/reseller-billing"];

const menuItems = [
  {
    section: "PRINCIPAL",
    items: [
      { label:"Dashboard",       path:"/dashboard",   icon:"grid"     },
      { label:"CDR Llamadas",    path:"/cdr",         icon:"phone",   badge:"Live" },
      { label:"CDR Tiempo Real", path:"/cdr-live",    icon:"live",    badge:"WS"   },
      { label:"Métricas",     path:"/metricas",    icon:"bar"      },
    ],
  },
  {
    section: "NOC / SEGURIDAD",
    items: [
      { label:"Network Map",     path:"/network",     icon:"network"  },
      { label:"Antifraude",      path:"/antifraude",  icon:"shield"   },
      { label:"Monitor de Carriers SIP", path:"/carrier-monitor", icon:"signal",  badge:"LIVE" },
      { label:"Alertas",          path:"/alerts",          icon:"alert"   },
      { label:"Firewall UFW",    path:"/ufw",             icon:"lock"    },
      { label:"Eneural SBC",     path:"/kamailio-sbc",    icon:"shield",  badge:"NUEVO", children:[
        { label:"Clientes SBC",  path:"/kamailio-sbc/clientes",     emoji:"👥" },
        { label:"Debug",         path:"/kamailio-sbc/debug",        emoji:"🔍" },
        { label:"Firewall",      path:"/kamailio-sbc/firewall",     emoji:"🔒" },
        { label:"Estadísticas",  path:"/kamailio-sbc/estadisticas", emoji:"📊" },
      ] },
    ],
  },
  {
    section: "CLIENTES",
    items: [
      { label:"Clientes",  path:"/clientes-v2",    icon:"search"   },
    ],
  },
  {
    section: "COMERCIAL",
    items: [
      { label:"Carriers / Trunks", path:"/carriers",    icon:"share"  },
      { label:"Enrutamiento",      path:"/routing",     icon:"network" },
      { label:"Planes de cobro",   path:"/planes",      icon:"credit" },
      { label:"Series DID",        path:"/dids",        icon:"hash"   },
      { label:"Discado corto",     path:"/discado-corto", icon:"phone" },
      { label:"Permisos ANI",      path:"/permisos",    icon:"shield" },
      { label:"Historial ANI",     path:"/historial-ani", icon:"clock" },
      { label:"Billing",           path:"/billing",     icon:"bill"   },
      { label:"Recaudación",       path:"/recaudacion", icon:"credit" },
    ],
  },
  {
    section: "INTEGRACIONES",
    items: [
      { label:"API Center",      path:"/api-center",   icon:"api"      },
      { label:"Revendedores",    path:"/revendedores", icon:"reseller" },
      { label:"App Móvil",    path:"/app",          icon:"mobile"   },
    ],
  },
  {
    section: "ADMINISTRACIÓN",
    items: [
      { label:"Usuarios",         path:"/usuarios",    icon:"users"    },
      { label:"Auditoría",        path:"/auditoria",   icon:"check",   superadmin:true },
      { label:"Reportes ARCOTEL", path:"/arcotel",     icon:"document" },
    ],
  },
  {
    section: "CONFIGURACIÓN",
    items: [
      { label:"Ajustes",         path:"/settings",    icon:"gear"     },
    ],
  },
];

const resellerMenu = [
  {
    section: "MI PORTAL",
    items: [
      { label:"Dashboard",       path:"/reseller-dashboard", icon:"grid"     },
      { label:"CDR Llamadas",    path:"/reseller-cdrs",      icon:"phone"    },
      { label:"Facturación",  path:"/reseller-billing",   icon:"bill"     },
    ],
  },
];

// Subdominios dedicados (migración a contenedores): cada uno muestra SOLO su módulo.
const recaudacionMenu = [
  { section: "RECAUDACIÓN", items: [
    { label:"Recaudación", path:"/recaudacion", icon:"credit" },
  ] },
];
const billingMenu = [
  { section: "BILLING", items: [
    { label:"Billing", path:"/billing", icon:"bill" },
  ] },
];

// Elige el menú según el host/superficie: recaudacion./billing.eneural.org muestran solo su
// módulo; clientes.eneural.org (rol sac) muestra SOLO gestión de cliente (/clientes-v2), sin
// nada de infra; el panel (mi.eneural.org) OCULTA Recaudación y Billing (viven en subdominios).
function menuPorHost(host, role, surface) {
  if (role === "revendedor") return resellerMenu;
  // El implementador existe solo para la gestion de clientes (decision de Carlos,
  // 2026-08-11): entre por el host que entre, no ve ningun item de infra.
  if (esSoloLectura(role)) {
    return menuItems
      .map(sec => ({ ...sec, items: sec.items.filter(i => i.path === "/clientes-v2") }))
      .filter(sec => sec.items.length > 0);
  }
  if (surface === "clientes") {
    // Superficie acotada: se deriva del menú real filtrando solo el ítem de gestión de
    // cliente, así conserva su sección/ícono/label sin exponer ningún ítem de infra.
    return menuItems
      .map(sec => ({ ...sec, items: sec.items.filter(i => i.path === "/clientes-v2") }))
      .filter(sec => sec.items.length > 0);
  }
  if (host.startsWith("recaudacion.")) return recaudacionMenu;
  if (host.startsWith("billing."))     return billingMenu;
  return menuItems.map(sec => ({
    ...sec,
    items: sec.items.filter(i => i.path !== "/recaudacion" && i.path !== "/billing"),
  }));
}

export default function Sidebar() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { user }  = useAuth();
  const initials  = user?.username ? user.username.slice(0,2).toUpperCase() : "AD";

  const host    = typeof window !== "undefined" ? window.location.hostname : "";
  const surface = surfaceFromHost(host);
  const brand = surface === "recaudacion" ? "Netvoice Recaudación"
              : surface === "billing"     ? "Netvoice Billing"
              : surface === "clientes"    ? "Netvoice Clientes"
              : "Netvoice Panel";

  return (
    <aside className="sidebar">
      <div className="sidebar-logo">
        <div className="brand">
          <span className="brand-dot"/>
          {brand}
        </div>
      </div>
      <nav className="sidebar-nav">
        {menuPorHost(host, user?.role, surface).map(({ section, items }) => (
          <div key={section} className="nav-section">
            <span className="nav-section-label">{section}</span>
            {items
              .filter(i => !i.superadmin || user?.role === "superadmin" || user?.role === "admin")
              .map(({ label, path, icon, badge, children }) => {
                const active = location.pathname === path ||
                  (path !== "/dashboard" && location.pathname.startsWith(path) && path.length > 1);
                const showSub = children && location.pathname.startsWith(path);
                return (
                  <Fragment key={path}>
                    <button className={"nav-item"+(active?" active":"")}
                            onClick={()=>navigate(children ? children[0].path : path)}>
                      <I n={icon}/>
                      {label}
                      {badge && <span className="nav-badge">{badge}</span>}
                    </button>
                    {showSub && children.map(ch => {
                      const chActive = location.pathname === ch.path;
                      return (
                        <button key={ch.path}
                                className={"nav-item"+(chActive?" active":"")}
                                style={{ paddingLeft: 32, fontSize: "0.8rem", opacity: chActive ? 1 : 0.72 }}
                                onClick={()=>navigate(ch.path)}>
                          <span style={{ width: 14, display:"inline-flex", justifyContent:"center", fontSize:"0.85rem" }}>{ch.emoji}</span>
                          {ch.label}
                        </button>
                      );
                    })}
                  </Fragment>
                );
              })
            }
          </div>
        ))}
      </nav>
      <div className="sidebar-bottom">
        <div className="user-row">
          <div className="user-avatar">{initials}</div>
          <div>
            <div className="user-name">{user?.username||"admin"}</div>
            <div className="user-role">{user?.role||"Administrador"}</div>
          </div>
        </div>
      </div>
    </aside>
  );
}

